module.exports = __webpack_public_path__ + "img/min_yuan2.150991d6.png";